export default {
  show: ({ url }) => window.open(url, '_blank'),
  dismiss: () => {},
  isAvailable: () => Promise.resolve(false),
};
